import styles from './index.module.css'
import clsx from 'clsx'

import React from 'react'
import { Link } from 'react-router-dom'
import Icon from 'components/ui/icon'
type Item = Record<string, any>
type Props = {
  items: Item[]
}

const Items: (
  arg0: Item,
  index: number,
) => React.ReactNode | React.ReactElement<'label'> = (
  {
    // TODO: refactor TabNav and TabStepsNav and remove unused props
    active,
    className,
    label,
    link,
    icon,
    alias,
    disabled,
    hidden,
    onClick,
    completed,
    ...rest
  }: Item,
  index: number,
) => {
  const rootClass = clsx(styles.label, {
    [styles['label--active']]: active,
    [styles['label--completed']]: completed,
  })
  const rootIndicatorClass = clsx(styles['step-indicator'], {
    [styles['step-indicator--active']]: active,
    [styles['step-indicator--completed']]: completed,
  })
  return link ? (
    <Link
      to={link}
      key={index}
      {...rest}
      className={rootClass}
      onClick={disabled ? null : onClick}
    >
      <div className={rootIndicatorClass}>
        {completed && <Icon type="check" />}
      </div>
      <div>{label}</div>
    </Link>
  ) : (
    <label
      key={index}
      {...rest}
      className={rootClass}
      onClick={disabled ? null : onClick}
    >
      <div className={rootIndicatorClass}>
        {completed && <Icon type="check" />}
      </div>
      <div>{label}</div>
    </label>
  )
}

const TabStepsNav = (
  props: Props,
): React.ReactElement<'div'> | React.ReactElement<'nav'> => {
  const { items } = props
  return <nav className={styles.nav}>{items.map(Items)}</nav>
}

export default TabStepsNav
